<template>
  <div class="nav-bar-container">
    <el-row :gutter="20">
      <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="4">
        <div class="left-panel">
          <fold />
          <el-tabs v-if="layout === 'comprehensive'" v-model="firstMenu" tab-position="top" @tab-click="handleTabClick">
            <el-tab-pane v-for="item in handleRoutes" :key="item.path" :name="item.path">
              <div slot="label">
                <vab-remix-icon v-if="item.meta.remixIcon" :icon="item.meta.remixIcon" class="vab-remix-icon" />
                {{ translateTitle(item.meta.title) }}
              </div>
            </el-tab-pane>
          </el-tabs>
          <breadcrumb v-else class="hidden-xs-only" />
        </div>
      </el-col>
      <!-- <el-col :lg="6" :md="6" :sm="6" :xl="6" :xs="4">

      </el-col> -->
      <!-- 当前操作项目 -->
      <el-col :lg="18" :md="18" :sm="18" :xl="18" :xs="4">
        <!-- <div class="center-panel" style="margin-top:15px;font-weight:bold;">

        </div> -->
        <div class="right-panel">
          <!-- <error-log /> -->
          <span style="font-weight:bold;">项目类别：</span>
          <el-select v-model="selectType" :rows="2" placeholder="请选择项目类别" style="width:140px" @change="typeChangeEvent">
            <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>

          <span style="font-weight:bold;margin-left:20px">选择项目:【{{ prjInfo.prjTitle }}】</span>
          <el-button size="mini" type="primary" plain icon="el-icon-search" circle @click="prjClick"></el-button>
          <full-screen />
          <avatar />
        </div>
      </el-col>
    </el-row>

    <el-drawer
      title="项目选择"
      :visible.sync="isPrjtable"
      direction="rtl"
      size="400px"
      :modal="true"
      :wrapper-closable="true"
      :modal-append-to-body="false"
      @closed="drawerClosed"
    >
      <el-input class="topText" v-model="filterText" placeholder="输入关键字进行过滤"></el-input>
      <el-tree
        ref="tree"
        class="filter-tree"
        :data="projectOptions"
        node-key="id"
        :props="defaultProps"
        default-expand-all
        :filter-node-method="filterNode"
        :current-node-key="prjInfo.prjId.toLowerCase()"
        :highlight-current="true"
        @node-click="checkSingleClick"
        @check-change="chgPrjClick"
      ></el-tree>
    </el-drawer>
  </div>
</template>

<script>
import { translateTitle } from '@/utils/i18n';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { openFirstMenu } from '@/config';
import { getProjectType } from '@/api/02prjplan/designprojectdef';
import store from '@/store';
export default {
  name: 'NavBar',
  props: {
    layout: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      firstMenu: '',
      dialogVisible: false,
      isPrjtable: false,
      filterText: '',
      defaultProps: {
        children: 'children',
        label: 'title',
      },
      selectType: '',
      typeList: [],
      projectOptions: [],
      designList: [],
    };
  },

  computed: {
    ...mapGetters({
      routes: 'routes/routes',
      userInfo: 'user/userInfo',
      prjInfo: 'user/prjInfo',
      prjList: 'user/prjList',
      prjType: 'user/prjType',
      prjListMarket: 'user/prjListMarket',
      prjListDesign: 'user/prjListDesign',
    }),
    handleRoutes() {
      return this.routes.filter((item) => item.hidden !== true && item.meta);
    },
  },
  watch: {
    $route: {
      handler(route) {
        const firstMenu = route.matched[0].path || '/';
        if (this.firstMenu !== firstMenu) {
          this.firstMenu = firstMenu;
          this.handleTabClick({ name: firstMenu }, true);
        }
      },
      immediate: true,
    },
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  async created() {
    let prjTypeRes = await getProjectType();
    this.designList = prjTypeRes.result.map((v) => {
      v.value = v.Title;
      v.label = '设计_' + v.Title;
      return v;
    });
    this.typeList = [
      // { value: '工程项目', label: '工程项目' },
      // { value: '市场项目', label: '市场项目' },
    ];
    this.designList.forEach((element) => {
      this.typeList.push(element);
    });
    this.typeList.push({ value: 'TCDRI', label: 'TCDRI全局非项目' });

    await this.getPrjList(this.userInfo.userId);
    await this.getPrjListMarket(this.userInfo.userId);
    await this.getPrjListDesign({ userId: this.userInfo.userId, typeList: this.typeList });
    this.selectType = this.prjType;
    //页面初始化的时候
    //1.给项目类别赋值
    this.typeChangeEvent(this.selectType);
    //2.根据登陆人+项目id  运行切换项目的方法————获取roles来更新菜单路由
    let prjRoleInfo = { prjId: this.prjInfo.prjId, userId: this.userInfo.userId };
    // console.log(this.route)
    // await store.dispatch('user/getprjRoleInfo', prjRoleInfo)
  },
  methods: {
    translateTitle,
    ...mapActions({
      setPartialRoutes: 'routes/setPartialRoutes',
      delAllVisitedRoutes: 'tabsBar/delAllVisitedRoutes',
      getPrjList: 'user/getPrjList',
      getPrjListMarket: 'user/getPrjListMarket',
      getPrjListDesign: 'user/getPrjListDesign',
    }),
    ...mapMutations({
      setProjectId: 'user/setProjectId', //【设计】 待删除
      setProjectName: 'user/setProjectName', //【设计】 待删除
      chgPrjInfo: 'user/chgPrjInfo',
      chgPrjType: 'user/chgPrjType',
    }),

    handleTabClick(tab, mounted) {
      const childrenArr = this.routes.find((item) => item.path === tab.name).children;
      this.setPartialRoutes(childrenArr);
      if (mounted !== true && openFirstMenu) this.$router.push(childrenArr[0].path);
    },

    async prjClick() {
      this.isPrjtable = true;
      await this.getPrjListDesign({ userId: this.userInfo.userId, typeList: this.typeList });
      this.typeChangeEvent(this.selectType);
    },

    //树的操作：
    chgPrjClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([data]);
      }
    },
    //选择框被单击时isCheck  改变项目
    checkSingleClick(data) {
      if (data.children.length == 0) {
        this.$confirm('确定要切换项目吗？已经输入的数据可能会丢失,请先保存', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            this.chgPrjInfo(data);
            this.chgPrjType(this.selectType);
            //根据切换的项目 和 人员 得到人员的 角色组 专业  角色权限*********
            let prjRoleInfo = { prjId: this.prjInfo.prjId, userId: this.userInfo.userId, prjType: this.prjInfo.prjType };
            await store.dispatch('user/getprjRoleInfo', prjRoleInfo);

            this.$refs.tree.setCurrentKey(this.prjInfo.prjId.toLowerCase());

            this.$router.replace({
              path: '/refresh',
              query: {
                t: Date.now(),
              },
            });
            this.isPrjtable = false;
          })
          .catch(() => {
            this.isPrjtable = false;
          });
      }
    },
    drawerClosed() {
      this.$refs.tree.setCurrentKey(this.prjInfo.prjId.toLowerCase());
    },
    //tree的筛选方法
    filterNode(value, data) {
      if (!value) return true;
      return data.title.toUpperCase().indexOf(value.toUpperCase()) !== -1;
    },
    typeChangeEvent(data) {
      let prjListTop = JSON.parse(JSON.stringify(this.prjList)); //彭妙培  20220506 为了表达非项目数据增加分类
      console.log('prjListTop: ', prjListTop);
      if (prjListTop && prjListTop.length > 0) {
        prjListTop[0].children = [];
      }
      if (data == '工程项目') {
        // this.projectOptions = this.prjList
      } else if (data == '市场项目') {
        this.projectOptions = this.prjListMarket;
      } else if (data == 'TCDRI') {
        this.projectOptions = prjListTop;
      } else if (Object.keys(this.prjListDesign).indexOf(data) > -1) {
        this.projectOptions = this.prjListDesign[data];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.topText {
  position: absolute;
  top: 60px;
  width: 90%;
  z-index: 99;
}
.nav-bar-container {
  position: relative;
  height: $base-nav-bar-height;
  padding-right: $base-padding;
  padding-left: $base-padding;
  overflow: hidden;
  user-select: none;
  background: $base-color-white;
  box-shadow: $base-box-shadow;

  .left-panel {
    display: flex;
    align-items: center;
    justify-items: center;
    height: $base-nav-bar-height;

    ::v-deep {
      .breadcrumb-container {
        margin-left: $base-padding;
      }

      .el-tabs {
        margin-left: $base-padding;

        .el-tabs__header {
          margin: 0;
        }

        .el-tabs__item {
          > div {
            display: flex;
            align-items: center;

            i {
              margin-right: 3px;
            }
          }
        }
      }

      .el-tabs__nav-wrap::after {
        display: none;
      }
    }
  }

  .right-panel {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: flex-end;
    height: $base-nav-bar-height;

    ::v-deep {
      [class*='ri-'] {
        margin-left: $base-padding;
        color: $base-color-gray;
        cursor: pointer;
      }

      button {
        [class*='ri-'] {
          margin-left: 0;
          color: $base-color-white;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-dropdown-menu__item {
  display: flex;
  align-content: center;
  align-items: center;

  svg {
    margin-right: 3px;
  }
}
.el-drawer__body {
  overflow: auto;
  padding: 15px;
}
.el-tree {
  .el-tree-node {
    white-space: normal;
    .el-tree-node__content {
      height: 100%;
      padding: 2px;
      line-height: 1.4em;
    }
  }
}
</style>
